import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from '@axios'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'da',
  fallbackLocale: 'da',
})

async function loadLocaleMessages() {
  const response = await axios.get('/translations/get-translations')
  // const response1 = await axios.get('/settings/get-countries-dropdown')

  // for (const [lang1, trans1] of Object.entries(response1.data.data)) {
  //   if (lang1 === 'en') {
  //     response.data.data.en.COUNTRIES_DROP_DOWN = trans1
  //   }
  //   if (lang1 === 'da') {
  //     response.data.data.da.COUNTRIES_DROP_DOWN = trans1
  //   }
  // }
  for (const [lang, trans] of Object.entries(response.data.data)) {
    i18n.setLocaleMessage(lang, trans)
  }
}

(function checkLocalStorageLocale() {
  const locale = localStorage.getItem('locale')
  if (locale) i18n.locale = locale
}())

loadLocaleMessages()

export default i18n
